// Recovered compiled webpack factory 2877. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { $: () => p });
  var n = i(63354),
    s = i(51118),
    r = i(88786),
    o = i(22039),
    a = i(21767),
    l = i(7112),
    h = i(23781),
    u = i(60738),
    d = i(77217),
    c = i(73934);
  function p(t, e, { delay: i = 0, transitionOverride: m, type: f } = {}) {
    let { transition: v, transitionEnd: y, ...g } = e,
      x = t.getDefaultTransition();
    v = v ? (0, s.K)(v, x) : x;
    let w = v?.reduceMotion;
    m && (v = m);
    let T = [],
      b = f && t.animationState && t.animationState.getState()[f];
    for (let e in g) {
      let s = t.getValue(e, t.latestValues[e] ?? null),
        o = g[e];
      if (
        void 0 === o ||
        (b &&
          (function ({ protectedKeys: t, needsAnimating: e }, i) {
            let n = t.hasOwnProperty(i) && !0 !== e[i];
            return ((e[i] = !1), n);
          })(b, e))
      )
        continue;
      let a = { delay: i, ...(0, n.r)(v || {}, e) },
        l = s.get();
      if (void 0 !== l && !s.isAnimating() && !Array.isArray(o) && o === l && !a.velocity) {
        c.Gt.update(() => s.set(o));
        continue;
      }
      let p = !1;
      if (window.MotionHandoffAnimation) {
        let i = (0, u.P)(t);
        if (i) {
          let t = window.MotionHandoffAnimation(i, e, c.Gt);
          null !== t && ((a.startTime = t), (p = !0));
        }
      }
      (0, h.g)(t, e);
      let m = w ?? t.shouldReduceMotion;
      s.start((0, d.f)(e, s, o, m && r.$.has(e) ? { type: !1 } : a, t, p));
      let f = s.animation;
      f && T.push(f);
    }
    if (y) {
      let e = () =>
        c.Gt.update(() => {
          y &&
            (function (t, e) {
              let { transitionEnd: i = {}, transition: n = {}, ...s } = (0, a.K)(t, e) || {};
              for (let e in (s = { ...s, ...i })) {
                var r;
                let i = ((r = s[e]), (0, l.p)(r) ? r[r.length - 1] || 0 : r);
                t.hasValue(e) ? t.getValue(e).set(i) : t.addValue(e, (0, o.OQ)(i));
              }
            })(t, y);
        });
      T.length ? Promise.all(T).then(e) : e();
    }
    return T;
  }
}
